const COLOR_SCHEMES = [
    "blue",
    "indigo",
    "violet",
    "purple"
];
/**
 * Generate a consistent color scheme from a string (e.g., role name, entity ID)
 * Same input always produces same color for visual consistency
 */ export function getColorSchemeFromString(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % COLOR_SCHEMES.length;
    return COLOR_SCHEMES[index];
}

//# sourceMappingURL=badge-utils.js.map